import { SuperSource } from '@slite/search-client'

export const DEFAULT_SOURCE_TYPES = [
  SuperSource.SLACK_CHANNEL,
  SuperSource.CONFLUENCE,
  SuperSource.SLITE,
  SuperSource.HUBSPOT,
  SuperSource.ATTIO,
  SuperSource.INTERCOM,
  SuperSource.NOTION,
  SuperSource.GITHUB,
]

export const STATIC_ORBIT_CONFIGS = [
  { radius: 45, isInnermost: true },
  { radius: 110, isInnermost: false },
  { radius: 158, isInnermost: false },
  { radius: 220, isInnermost: false },
]

export const ORBITE_SIZE_PRESETS = {
  small: { circleRadius: 12, iconSize: 10, wrapperSize: 20 },
  medium: { circleRadius: 20, iconSize: 16, wrapperSize: 32 },
  large: { circleRadius: 24, iconSize: 20, wrapperSize: 40 },
} as const

export type OrbiteSizePreset = keyof typeof ORBITE_SIZE_PRESETS
